import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const TOKEN_KEY = "tjh_admin_token";

const AdminContext = createContext(null);

export function AdminProvider({ children }) {
  const [token, setToken] = useState(() => localStorage.getItem(TOKEN_KEY) || null);
  const [admin, setAdmin] = useState(undefined); // undefined = loading, null = not logged in

  const authHeader = useCallback(() => ({ headers: { Authorization: `Bearer ${localStorage.getItem(TOKEN_KEY)}` } }), []);

  const loadMe = useCallback(async () => {
    const t = localStorage.getItem(TOKEN_KEY);
    if (!t) { setAdmin(null); return; }
    try {
      const { data } = await axios.get(`${API}/admin/me`, { headers: { Authorization: `Bearer ${t}` } });
      setAdmin(data);
    } catch {
      localStorage.removeItem(TOKEN_KEY);
      setToken(null);
      setAdmin(null);
    }
  }, []);

  useEffect(() => { loadMe(); }, [loadMe]);

  const login = async (email, password) => {
    const { data } = await axios.post(`${API}/admin/login`, { email, password });
    localStorage.setItem(TOKEN_KEY, data.token);
    setToken(data.token);
    setAdmin(data.admin);
    return data.admin;
  };

  const logout = () => {
    localStorage.removeItem(TOKEN_KEY);
    setToken(null);
    setAdmin(null);
  };

  const changePassword = async (current_password, new_password) => {
    await axios.post(`${API}/admin/change-password`, { current_password, new_password }, authHeader());
    setAdmin((a) => ({ ...a, must_change_password: false }));
  };

  return (
    <AdminContext.Provider value={{ token, admin, login, logout, changePassword, authHeader, reload: loadMe, API }}>
      {children}
    </AdminContext.Provider>
  );
}

export const useAdmin = () => useContext(AdminContext);
